import axios, { AxiosRequestConfig } from "axios";
import { buscaUsuarios, todoUsuario } from "../types/usuarios";

export const getUsuarios = async (token: string): Promise<buscaUsuarios[]> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/usuario`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar usuários:", error);
    throw error;
  }
};

export const getUsuarioById = async (
  token: string,
  id: string,
): Promise<todoUsuario> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/usuario/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar usuários:", error);
    throw error;
  }
};

export const createUsuario = async (token: string, usuarioData: FormData) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/usuario`;
    const response = await axios.post(url, usuarioData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar usuário:", error);
    throw error;
  }
};

export const createTipoUsuario = async (
  token: string,
  idUsuario: string,
  idTipo: number,
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/tipousuario`;
    const response = await axios.post(
      url,
      {
        id_usuario: idUsuario,
        id_tipo: idTipo,
      },
      config,
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar tipo no usuário:", error);
    throw error;
  }
};

export const updateUsuario = async (
  token: string,
  id: string,
  usuarioData: FormData,
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/usuario/${id}`;
    const response = await axios.put(url, usuarioData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar usuário:", error);
    throw error;
  }
};

export const deleteUsuario = async (token: string, id: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/usuario/${id}`;
    const response = await axios.delete(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao excluir usuário:", error);
    throw error;
  }
};

export const ativaUsuario = async (token: string, id: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/usuario/ativa/${id}`;
    const response = await axios.put(url, {}, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao ativar usuário:", error);
    throw error;
  }
};
